function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.83276,
  cy: 8.87766,
  rx: 7.16602,
  ry: 7.21104,
  stroke: "#7E8897",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M18.385 19.546C18.1066 19.537 17.842 19.4225 17.644 19.2254L15.9469 17.2418C15.5831 16.9091 15.5534 16.3436 15.8802 15.9741C16.0332 15.8192 16.2413 15.7322 16.4583 15.7322C16.6753 15.7322 16.8833 15.8192 17.0363 15.9741L19.1705 17.6818C19.478 17.9964 19.5728 18.4635 19.4127 18.8743C19.2526 19.2851 18.8675 19.5628 18.4295 19.5833L18.385 19.546Z",
  fill: "#7E8897"
});

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.89809647.svg";
export { ForwardRef as ReactComponent };